import { Container } from '@seek/ai-elements';
import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import type { FC } from 'react';

import { SparklingBadgeIcon } from 'src/libs/Icons';

import translations from './.vocab';
import { isBadgeVariant, type Variant } from './variant';

import * as styles from './HighFitBadge.css';

type HighFitBadgeProps = {
  variant: Variant;
};

export const HighFitBadge: FC<HighFitBadgeProps> = ({ variant }) => {
  const { t } = useTranslations(translations);
  const isBadge = isBadgeVariant(variant);

  return (
    <Container
      borderWidth="standard"
      display="flex"
      flexDirection="row"
      alignItems="center"
      maxWidth="content"
      borderRadius={isBadge ? 'standard' : 'xlarge'}
      paddingY={isBadge ? 'xxsmall' : 'xsmall'}
      paddingX={isBadge ? 'xsmall' : 'small'}
    >
      <Text
        size="xsmall"
        weight="medium"
        icon={<SparklingBadgeIcon className={styles.iconContainer} />}
      >
        {t('High fit')}
      </Text>
    </Container>
  );
};
